// extracted by mini-css-extract-plugin
export default {"PolicyPreviewButton__button":"PolicyPreviewButton__button_WvVxS","PolicyPreviewButton__icon":"PolicyPreviewButton__icon_u7OfM"};